// extracted by mini-css-extract-plugin
export default {"container":"ZJ-z","topReviewHeading":"_J-z","criticalReview":"aK-z","favorableReview":"bK-z","vsSeparator":"cK-z"};